/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGenderFemale = createReactComponent("gender-female", "IconGenderFemale", [
  ["path", { d: "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", key: "svg-0" }],
  ["path", { d: "M12 14v7", key: "svg-1" }],
  ["path", { d: "M9 18h6", key: "svg-2" }]
]);

export { IconGenderFemale as default };
//# sourceMappingURL=IconGenderFemale.js.map
